import { render } from "./Person.svg?vue&type=template&id=8c5c1784"
const script = {}
script.render = render

export default script